var React = require('react');

function LegalInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M46.4597 62.7941L51.8005 70.2709H33.6424L42.7213 59.3227C42.7213 59.3227 42.7213 32.7535 42.7213 15.7292M42.7213 15.7292C40.7537 22.7389 35.3884 27.646 21.2894 28.7141L14.1328 47.8464C13.5771 54.2614 25.4142 60.9667 30.9554 47.8464H18.4052L23.9598 32.9865L29.3003 44.0342H57.0746L61.1538 33.1599L66.6014 47.2385H55.3456C55.3456 52.6853 64.9678 60.6296 71.8861 49.8797L63.5496 28.5466C56.6068 27.3894 42.7213 23.2059 42.7213 15.7292Z","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

LegalInline.defaultProps = {"width":"86","height":"86","viewBox":"0 0 86 86","fill":"none"};

module.exports = LegalInline;

LegalInline.default = LegalInline;
